import React from "react"

const IconInfo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <rect
        width="24"
        height="24"
        x="4"
        y="4"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        rx="12"
      ></rect>
      <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 17v-7"></path>
      <path stroke="#fff" strokeLinejoin="round" strokeWidth="2" d="M16 22v-2"></path>
    </svg>
  )
}

export default IconInfo
